
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { singularityStore } from "@/store/store";
import { SingularityUIState } from "@/store/modules/singularity";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    Icon
  }
})
export default class PanelHeader extends Vue {
  @Prop({ default: "Title" }) parentTitle!: string;

  @Prop() childTitle!: string | null;

  @Prop() backState!: SingularityUIState["singularityLeftPanel"] | null;

  goBackToPanelState() {
    return this.backState
      ? singularityStore.setSingularityLeftPanel(this.backState)
      : null;
  }
}
